import type {Components, Theme} from '@mui/material/styles';
import ChevronIcon from '~/icons/svg/ChevronIcon.svg?react';

export const selectOverrides: Components<Theme>['MuiSelect'] = {
    defaultProps: {
        IconComponent: ChevronIcon,
    },
    styleOverrides: {
        // ChevronIcon points right; rotate to face down / up when open
        icon: {
            top: 'calc(50% - 12px)',
            transform: 'rotate(90deg)',
        },
        iconOpen: {
            transform: 'rotate(-90deg)',
        },
    },
};
